export default __webpack_public_path__ + "static/media/office8full.9a7661ee.jpg";